import { appStore } from "../store/store";

export const initYandexMetrica = () => {
  const id = appStore.config?.yandex_metrika_id;
  if (!id) return;

  (function (m, e, t, r, i, k, a) {
    /* eslint-disable @typescript-eslint/no-unused-expressions */
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
      if (document.scripts[j].src === r) {
        return;
      }
    }
    ((k = e.createElement(t)),
      (a = e.getElementsByTagName(t)[0]),
      (k.async = 1),
      (k.src = r));
    a.parentNode.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  window.ym(id, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });
};

export const initGoogleAnalytics = () => {
  const id = appStore.config?.google_analytics_id;
  if (!id) return;

  (function () {
    var script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

    script.onload = function () {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", id);
    };

    document.head.appendChild(script);
  })();
};
